<!-- Main container -->
<div class="layout-col full">
  <elder-table class="flex" matSort [data]="properties$ | async" [selectionVisible]="false">
    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
      <td mat-cell *matCellDef="let row">
        <span class="layout-row place-start-center">
          <mat-icon>label</mat-icon>
        </span>
      </td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef style="width: 25%">
        {{ 'context.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let propertyConf">
        <div class="layout-col">
          <div>{{ propertyConf?.property?.description }}</div>
          <div class="text-body-small">{{ propertyConf?.propertyId }}</div>
        </div>
      </td>
    </ng-container>

    <!-- value Column -->
    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef>{{ 'context.value' | translate }}</th>
      <td mat-cell *matCellDef="let propertyConf; let i = index">
        <app-property-input
          [name]="name + '-value-' + i"
          [property]="propertyConf.property"
          [required]="propertyConf?.spec?.inputRequired"
          [singleSelection]="propertyConf?.spec?.singleSelection"
          [(values)]="propertyConf.values"
        >
        </app-property-input>
      </td>
    </ng-container>
  </elder-table>
</div>
